import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e2873d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dt-card signage__container" }
const _hoisted_2 = { class: "dt-card__heading-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "dt-card__heading-title float-start" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "dt-card__heading-title float-start" }
const _hoisted_7 = {
  ref: "signageDetailsBody",
  class: "dt-card__body"
}
const _hoisted_8 = {
  key: 0,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_10 = {
  key: 1,
  class: "callout callout--no-max callout--informational"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--informational",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Generating signage. It may take a few moments to appear.", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Requires saving before preview can be rendered.", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "New media uploads must be saved before a preview can be generated.", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { key: 4 }
const _hoisted_23 = {
  key: 5,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Preview", -1))
const _hoisted_27 = {
  "element-loading-text": "Building Preview...",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "draggable-modal__image-container" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  class: "draggable-modal__fs-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_LiveTemplatePreview = _resolveComponent("LiveTemplatePreview")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_DraggableModal = _resolveComponent("DraggableModal")!
  const _component_Lightbox = _resolveComponent("Lightbox")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_scroll_shadow = _resolveDirective("scroll-shadow")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'dt-card__heading'  : _ctx.windowWidth.value >= 576 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isImport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: _ctx.signageItem.name,
                placement: "bottom-start",
                "show-after": 500,
                "hide-after": 0,
                disabled: _ctx.isEditingItemName
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_4, [
                    (_ctx.isEditingItemName)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "dt-inline-input",
                          ref: "editItemNameInput",
                          onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditingItemName = false)),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItem.name) = $event)),
                          onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
                        }, null, 544)), [
                          [_vModelText, _ctx.signageItem.name]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.signageItem.name), 1)
                        ], 64))
                  ])
                ]),
                _: 1
              }, 8, ["content", "disabled"]),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Rename",
                placement: "bottom",
                "show-after": 500,
                "hide-after": 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    onClick: _ctx.toggleEditListNameInput,
                    class: "signage__item-rename",
                    icon: _ctx.mdiPencil
                  }, null, 8, ["onClick", "icon"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.signageItem.name), 1)
            ]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'mt-3 text-end' : _ctx.windowWidth.value < 576 })
      }, [
        _createVNode(_component_router_link, {
          to: '/signage/' + _ctx.$route.params.listid + '#signage'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { class: "ms-3" }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        (!_ctx.isImport)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: _ctx.isUpdateSignageItemLoading || _ctx.isLoadingUpdatedPreview || !_ctx.isValidMediaLayout || _ctx.isLayoutDisbabled,
              class: "ms-3",
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                (_ctx.isLoadingUpdatedPreview)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Building...")
                    ], 64))
                  : (_ctx.fileUploadQueue && _ctx.fileUploadQueue.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Upload & Save")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("Save Item")
                      ], 64))
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])), [
              [_directive_loading, _ctx.isUpdateSignageItemLoading]
            ])
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["signage__item-callouts", {'signage__item-callouts--bottom-margin' : (!_ctx.showPreview)}])
      }, [
        (_ctx.signageItem.finalAssetGenerationError && _ctx.signageItem.layoutType !== 'youtubevideo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(_ctx.finalAssetGenerationErrorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        ((!_ctx.isCreatingNewSignageItem && _ctx.isImport && !_ctx.signageItem.finalSignageAsset && !_ctx.signageItem.finalAssetGenerationError) ||(_ctx.signageItem && _ctx.signageItem.finalSignageAsset && _ctx.signageItem.finalSignageAsset.remoteUploadPending))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.isSavingRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
          : _createCommentVNode("", true),
        (_ctx.fileUploadQueue && _ctx.fileUploadQueue.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
          : _createCommentVNode("", true),
        (_ctx.signageItem.storageQuotaMet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_TierLimit, {
                isCallout: true,
                message: "You have reached your signage storage limit! Upgrade your Ditto account to display this item."
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLayoutDisbabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", null, _toDisplayString(_ctx.featureWarningText), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_ctx.isYouTubeVideo && _ctx.iframeEmbeddedUrl)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    class: "signage__editor-preview-video",
                    src: _ctx.iframeEmbeddedUrl,
                    frameborder: "0",
                    allowfullscreen: "",
                    style: {"width":"100%","max-width":"640px","height":"330px","padding":"1rem"}
                  }, null, 8, _hoisted_28))
                : (_ctx.isLivePreviewSupported)
                  ? (_openBlock(), _createBlock(_component_LiveTemplatePreview, {
                      key: 1,
                      class: "signage__editor-live-preview",
                      "layout-type": _ctx.signageItem.layoutType,
                      "layout-data": _ctx.livePreviewLayoutData
                    }, null, 8, ["layout-type", "layout-data"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: "signage__editor-preview-image",
                      src: _ctx.signageItemPreviewImage
                    }, null, 8, _hoisted_29))
            ])), [
              [_directive_loading, _ctx.isLoadingUpdatedPreview && _ctx.shouldUpdatePreview && !_ctx.isLivePreviewSupported]
            ]),
            (!_ctx.isYouTubeVideo)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  plain: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPopoutPreviewVisible = !_ctx.isPopoutPreviewVisible))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      class: "me-2",
                      icon: _ctx.mdiOpenInNew
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.isPopoutPreviewVisible ? "Close" : "Popout") + " Preview ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_divider)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.signageItemEditorComponent), {
        layoutDataEdit: _ctx.layoutDataEdit,
        layoutDisbabled: _ctx.isLayoutDisbabled,
        playSoundEdit: _ctx.signageItem.playSound,
        layoutType: _ctx.signageItem.layoutType,
        signageAssets: _ctx.signageItem.signageAssets,
        isCreatingNewSignageItem: _ctx.isCreatingNewSignageItem,
        onUpdatePlaySound: _ctx.updatePlaySound,
        onUpdateLayoutData: _ctx.updateLayoutData,
        onIsUrlValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.youtubeUrlValid = $event))
      }, null, 40, ["layoutDataEdit", "layoutDisbabled", "playSoundEdit", "layoutType", "signageAssets", "isCreatingNewSignageItem", "onUpdatePlaySound", "onUpdateLayoutData"])),
      _createVNode(_component_DraggableModal, {
        title: "Signage Item Preview",
        modelValue: _ctx.isPopoutPreviewVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isPopoutPreviewVisible) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            (_ctx.isLivePreviewSupported && _ctx.isPopoutPreviewVisible)
              ? (_openBlock(), _createBlock(_component_LiveTemplatePreview, {
                  key: 0,
                  "layout-type": _ctx.signageItem.layoutType,
                  "layout-data": _ctx.livePreviewLayoutData
                }, null, 8, ["layout-type", "layout-data"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.signageItemPreviewImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "draggable-modal__image",
                        src: _ctx.signageItemPreviewImage
                      }, null, 8, _hoisted_31))
                    : _createCommentVNode("", true),
                  (_ctx.signageItemPreviewImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_component_Icon, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isLightboxVisible = true)),
                          class: "draggable-modal__fs-overlay-icon",
                          icon: _ctx.mdiFullscreen
                        }, null, 8, ["icon"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_Lightbox, {
        image: _ctx.signageItemPreviewImage,
        modelValue: _ctx.isLightboxVisible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isLightboxVisible) = $event))
      }, null, 8, ["image", "modelValue"])
    ])), [
      [_directive_scroll_shadow]
    ])
  ])), [
    [_directive_loading, _ctx.signageItemLoading]
  ])
}